import React, { Ref, forwardRef } from 'react'

import PrimaryHeader from '../../../components/primary-header'
import Title from '../../../components/title'
import MessageInput from '../../../components/message-input'
import Message from '../../../components/message'

import * as S from './styles'

import IProps from './props'

const Chat = forwardRef(
  (
    { messages, handleSend, interlocutor }: IProps,
    ref: Ref<HTMLDivElement>,
  ) => (
    <S.Container>
      <PrimaryHeader>
        <Title>
          Chat com
          {' '}
          <span>{interlocutor}</span>
        </Title>
      </PrimaryHeader>
      <S.Content>
        <S.Messages>
          {messages.map((message) => (
            <Message key={message.id} {...message} />
          ))}
        </S.Messages>
        <div ref={ref} className="message-end" />
      </S.Content>
      <MessageInput onSend={handleSend} />
    </S.Container>
  ),
)

export default Chat
